import styled from 'styled-components';

export const Wrap = styled.div`
  margin: 0 auto;
  color: ${props => props.theme.fieldTextColor};
  width: 80%;
  overflow-y: auto;
`;
